/*
 *
 * Example of Usage:
 *
 * <StepProgressBar barWidth="200px" stepsList=[
 *  {step: "1", title: "Title 1", active: true},
 *  {step: "2", title: "Title 2", active: false}] />
 *
 */

"use strict";

function StepProgressBar(props) {
  return (
    <ul className="stepProgressBar-list" style={{width: props.barWidth}}>
      {
        props.stepsList
        ? props.stepsList.map(function(stepItem, index){
            return <StepProgressBarItem {...stepItem} key={index}/>;
          })
        : null
      }
    </ul>
  );
}

function StepProgressBarItem(props) {
  let activeClass = props.active ? "active" : "";

  return (
    <li className={"stepProgressBar-item " + activeClass}>
      <div className="stepProgressBar-bar"></div>
      <div className="stepProgressBar-stepCircle">{props.step}</div>
      <div className="stepProgressBar-itemText">{props.title}</div>
    </li>
  );
}

StepProgressBar.defaultProps = {
  barWidth: "auto"
};

StepProgressBar.propTypes = {
  barWidth: React.PropTypes.string,
  stepsList: React.PropTypes.arrayOf(
    React.PropTypes.shape({
      step: React.PropTypes.string.isRequired,
      title: React.PropTypes.string.isRequired,
      active: React.PropTypes.bool.isRequired
    })
  ).isRequired
};

module.exports = StepProgressBar;



// WEBPACK FOOTER //
// ./app/shared/components/StepProgressBar/step-progress-bar.jsx